export var RenderType;
(function (RenderType) {
    RenderType["Button"] = "button";
    RenderType["Link"] = "link";
})(RenderType || (RenderType = {}));
